/* eslint-disable prefer-destructuring */
import { pr } from '@/utils/pxToRem';
import {
  Stack,
  TableContainer,
  Table,
  Paper,
  TableHead,
  TableBody,
} from '@mui/material';
import {
  useRef,
} from 'react';
import { Airlines_Name } from '../LunarNewYearAirfareByAirline';
import { style } from '@/styles/globals';
import { useAppDispatch, useAppSelector } from '@/utils/hook';
import { ListAreasItem } from '@/slices/goyoloSeo/sliceType';
import FlexTableRow from '@/components/FlexTableRow';
import WideTableCell from '@/components/WideTableCell';
import { convertThousand } from '@/utils/convertMoney';
import { TitleContentSub } from '../LunarNewYearAirfareByAirline';
import { StyledButton, TitleText } from '../LunarNewYearAirfareByPolularRoute';
import { format, isBefore } from 'date-fns';
import { getHostnameFromEnv } from '@/utils/getHostName';

const TableCel = ({ item, onSelectTrip, area }: any) => {
  const url = `https://${getHostnameFromEnv(process.env.APP_ENV || '')}/trip-detail?from=${area.startPoint.id}&to=${area.toPoint.id}&date[depart]=${item?.pickup_date}&passenger%5Badt%5D=1&passenger%5Bchd%5D=0&passenger%5Binf%5D=0&fare_class=PT&flightId[depart]=${item?.id}` || '';
  const newUrl = `${process.env.VEX_URL}/vn/ve-may-bay/dat-ve-may-bay.vi?from=${area.startPoint.id}&to=${area.toPoint.id}&date[depart]=${item?.pickup_date}&passenger[adt]=1&flightId[depart]=${item?.id || ''}`;

  return (
    <WideTableCell
      align="center"
      sx={{
        fontWeight: '500',
        color: style.primary.blue,
        minWidth: '93px',
        border: '1px solid #E0E0E0 !important',
        fontSize: '14px',
        lineHeight: '20px',
        textDecorationLine: 'underline',
        cursor: 'pointer',
      }}
    >
      {item?.total_price_adult ? (
        <a href={newUrl}>
          {`${convertThousand(Math.floor(item?.total_price_adult / 1000)).replace('.', '')}k`}
        </a>
      )
        : 'Đang cập nhật'}
    </WideTableCell>
  );
};

const Row = ({
  item, onSelectTrip, dataRoute,
}: { item: ListAreasItem, onSelectTrip: any, dataRoute: any }) => (
  <FlexTableRow
    sx={{
      '&:last-child td, &:last-child th': { border: 0 },
      display: 'flex',
    }}
  >
    <WideTableCell
      sx={{
        minWidth: '140px',
        color: style.neutral.black,
        border: '1px solid #E0E0E0 !important',
        background: '#fff',
        position: 'sticky',
        fontWeight: '400',
        fontSize: '14px',
        lineHight: '20px',
        left: 0,
      }}
    >
      {`${item.startPoint.stateName} - ${item.toPoint.stateName}`.replace('Hồ Chí Minh', 'Sài Gòn')}
    </WideTableCell>
    {(Object.keys(Airlines_Name) || []).map((key: any, i: number) => {
      const flightAl = dataRoute?.daysInNewYears?.find((flight: { id: string; }) => flight?.id?.split('|')[0] === key);
      return (
        <TableCel
          area={item}
          item={flightAl}
          key={JSON.stringify(flightAl)}
          onSelectTrip={onSelectTrip}
        />
      );
    })}
  </FlexTableRow>
);
const NewYearAirfareByPolularRoute = ({
  onSelectTrip, block, tetData,
}: { onSelectTrip: any, block: any, tetData: any }) => {
  const tetDataObj = JSON.parse(tetData);
  console.log('🚀 ~ tetDataObj:', tetDataObj);
  const newYearAirfareByPolularRoute = tetDataObj.newYearAirfareByPolularRoute;

  const refEl = useRef<any>();
  const listAreas = useAppSelector((state) => state.goyoloSeo.listAreas);
  const dispatch = useAppDispatch();
  const title = 'Bảng giá vé máy bay âm lịch theo hãng';
  const goRight = () => {
    if (refEl && refEl.current) {
      refEl.current.scrollLeft -= 80;
    }
  };
  const goLeft = () => {
    if (refEl) {
      refEl.current.scrollLeft += 80;
    }
  };
  const date = isBefore(new Date(), new Date('2024-12-31')) ? '2024-12-31' : format(new Date(), 'yyyy-MM-dd');

  return (
    <Stack
      sx={{
        minHeight: '50px',
        mt: '8px',
        boxShadow: 'none',
      }}
    >
      <TitleContentSub>
        So sánh giá vé tết dương lịch 2025 Vietnam Airlines, Vietjet Air, Bamboo Airways, Vietravel Airlines, Pacific Airlines những chặng bay phổ biến
        {' '}

      </TitleContentSub>
      <TitleText>Để đặt vé, bấm vào giá (đã bao gồm thuế, phí)</TitleText>
      <TableContainer
        component={Paper}
        sx={{
          minHeight: '50px',
          overflowX: 'auto',
          mt: '8px',
          boxShadow: 'none',
        }}
        ref={refEl}
      >
        <Table
          aria-label="simple table"
        >
          <TableHead>
            <FlexTableRow
              sx={{
                background: 'white',
                border: 0,
                display: 'flex',
              }}
            >
              <WideTableCell
                sx={{
                  minWidth: '140px',
                  background: '#F2F2F2',
                  position: 'sticky',
                  left: 0,
                }}
                align="center"
              />
              {Object.values(Airlines_Name).map((label: any, i: number) => {
                if (label) {
                  return (
                    <WideTableCell
                      key={label}
                      sx={{
                        ...(i === 0 ? { whiteSpace: 'nowrap' } : {}),
                        minWidth: '93px',
                        border: '1px solid #E0E0E0',
                        fontWeight: '500',
                        fontSize: '14px',
                        lineHight: '20px',
                      }}
                      align="center"
                    >
                      <div dangerouslySetInnerHTML={{ __html: label }} />
                    </WideTableCell>
                  );
                }
                return null;
              })}
            </FlexTableRow>
          </TableHead>
          <TableBody>
            {listAreas?.map((item, idx) => {
              const dataRoute = newYearAirfareByPolularRoute?.find((d: any) => d.route === `${item?.startPoint.id}-${item?.toPoint.id}`);
              return (
                <Row
                  onSelectTrip={onSelectTrip}
                  key={JSON.stringify(item)}
                  item={item}
                  dataRoute={dataRoute}
                />
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{
          marginTop: '12px',
        }}
      >
        <TitleText sx={{
          marginBottom: '0 !important',
        }}
        >
          Lịch hiển thị ngày
          {' '}
          {format(new Date(date), 'dd/MM/yyyy')}

        </TitleText>
      </Stack>
      <Stack
        direction="row"
        justifyContent="flex-end"
        spacing={pr`12px`}
        alignItems="center"
        sx={{
          marginRight: '24px',
        }}
      >
        <StyledButton onClick={goRight}>
          {' '}
          {'>'}
          {' '}
        </StyledButton>
        <StyledButton onClick={goLeft}>
          {' '}
          {'<'}
          {' '}
        </StyledButton>
      </Stack>
    </Stack>
  );
};

export default NewYearAirfareByPolularRoute;
